var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup36(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 9,
    height: 9,
    viewBox: "0 0 9 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.10219 2.20413C1.71084 2.20413 2.20425 1.71072 2.20425 1.10207C2.20425 0.493411 1.71084 0 1.10219 0C0.493534 0 0.00012207 0.493411 0.00012207 1.10207C0.00012207 1.71072 0.493534 2.20413 1.10219 2.20413Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.02045 2.94043H0.183678C0.0822875 2.94043 0 3.02272 0 3.12411V8.63444C0 8.73583 0.0822875 8.81811 0.183678 8.81811H2.02045C2.12184 8.81811 2.20413 8.73583 2.20413 8.63444V3.12411C2.20413 3.02272 2.12184 2.94043 2.02045 2.94043Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.49453 2.63478C6.70949 2.36587 5.72755 2.60208 5.13868 3.02564C5.11848 2.94666 5.04648 2.88788 4.96088 2.88788H3.12411C3.02272 2.88788 2.94043 2.97017 2.94043 3.07156V8.58189C2.94043 8.68328 3.02272 8.76557 3.12411 8.76557H4.96088C5.06227 8.76557 5.14456 8.68328 5.14456 8.58189V4.6218C5.44138 4.36612 5.8238 4.28457 6.13679 4.41755C6.44022 4.54576 6.61398 4.85874 6.61398 5.27569V8.58189C6.61398 8.68328 6.69627 8.76557 6.79766 8.76557H8.63444C8.73583 8.76557 8.81811 8.68328 8.81811 8.58189V4.90577C8.79717 3.3963 8.08708 2.83756 7.49453 2.63478Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup36);
export default __webpack_public_path__ + "static/media/Group36.e25f38a6001cbda4949cc7baced6c935.svg";
export { ForwardRef as ReactComponent };